import {
  FeatureName,
  useGrippContext,
  useIsFeatureEnabled,
  useStorageKeys,
} from '@gripp/shared-logic';
import {
  ChevronLeftIcon,
  RegisterForm,
  RegisterFormOld,
  colors,
  typography,
} from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { AuthSplitLayout } from './authSplitLayout';

export default function Register() {
  const navigate = useNavigate();
  const { storageHandler } = useGrippContext();
  const storageKeys = useStorageKeys();
  const { t } = useTranslation();
  const isCropCircleRedesign = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  const onVerify = async () => {
    await storageHandler.setItem(storageKeys.newRegister, 'register');
    navigate('/verify-auth-code');
  };

  if (isCropCircleRedesign) {
    const topBar = (
      <View>
        <Pressable
          style={styles.backNav}
          onPress={() => navigate('/login')}
          accessibilityRole="button"
          accessibilityLabel="Go back"
        >
          <ChevronLeftIcon size={24} color={colors.neutral[800]} />
        </Pressable>
        <View style={styles.titleSection}>
          <Text style={styles.titleText}>{t('login.aboutYourself')}</Text>
          <Pressable onPress={() => navigate('/login')}>
            <Text style={styles.subtitleText}>
              {t('login.existingAccount')}
            </Text>
          </Pressable>
        </View>
      </View>
    );

    return (
      <AuthSplitLayout topBar={topBar}>
        <RegisterForm onVerify={onVerify} onBack={() => navigate('/login')} />
      </AuthSplitLayout>
    );
  }

  return (
    <RegisterFormOld onVerify={onVerify} onBack={() => navigate('/login')} />
  );
}

const styles = StyleSheet.create({
  backNav: {
    padding: 12,
    alignSelf: 'flex-start',
  },
  titleSection: {
    alignItems: 'center',
    gap: 8,
    paddingHorizontal: 16,
    paddingBottom: 32,
  },
  titleText: {
    ...typography.display.largeEmphasised,
    textAlign: 'center',
    color: colors.neutral[800],
  },
  subtitleText: {
    ...typography.label.large,
    textAlign: 'center',
    color: colors.neutral[800],
    textDecorationLine: 'underline',
  },
});
